var _rect, _rect2, _rect3, _g, _rect4, _path, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _path2, _path3, _path4, _circle, _path5, _path6, _rect35, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _rect36, _rect37, _rect38, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _rect39, _circle2, _rect40, _rect41, _rect42, _rect43, _rect44, _path27, _path28, _path29, _path30, _rect45, _path31, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup300(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 460,
    height: 320,
    viewBox: "0 0 460 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 460,
    height: 320,
    rx: 8,
    fill: "#0B2878"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 40,
    width: 360,
    height: 240,
    rx: 8,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 310.5,
    y: 180.5,
    width: 79,
    height: 79,
    rx: 7.5,
    fill: "#0B2878",
    stroke: "#0B2878"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13202_46797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.657 203.478C359.24 201.061 356.04 199.74 352.626 199.74C349.211 199.74 346.001 201.071 343.585 203.488L342.322 204.75L341.041 203.468C338.624 201.051 335.405 199.711 331.99 199.711C328.585 199.711 325.376 201.042 322.969 203.449C320.552 205.865 319.221 209.075 319.231 212.49C319.231 215.904 320.571 219.104 322.988 221.521L341.364 239.896C341.618 240.151 341.96 240.287 342.293 240.287C342.626 240.287 342.968 240.16 343.223 239.906L361.637 221.56C364.054 219.143 365.385 215.934 365.385 212.519C365.394 209.104 364.074 205.895 361.657 203.478ZM359.778 219.691L342.293 237.108L324.847 219.662C322.929 217.744 321.873 215.2 321.873 212.49C321.873 209.779 322.92 207.235 324.837 205.327C326.745 203.419 329.289 202.363 331.99 202.363C334.7 202.363 337.254 203.419 339.172 205.337L341.383 207.548C341.902 208.067 342.733 208.067 343.252 207.548L345.444 205.357C347.361 203.439 349.915 202.382 352.616 202.382C355.316 202.382 357.86 203.439 359.778 205.347C361.696 207.265 362.743 209.809 362.743 212.519C362.753 215.229 361.696 217.773 359.778 219.691Z",
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 320.769,
    y: 218.46,
    width: 58.4615,
    height: 3.07692,
    fill: "#1E1E1E",
    stroke: "#0B2878",
    strokeWidth: 3.07692
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M379.231 219.999H346.923L342.308 231.922V212.884L335 219.999H320.769",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 190.5,
    y: 180.5,
    width: 79,
    height: 79,
    rx: 7.5,
    fill: "#0B2878",
    stroke: "#0B2878"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 196.922,
    width: 30.7692,
    height: 46.1538,
    rx: 4,
    fill: "#A3ACC2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 228.461,
    y: 196.922,
    width: 30.7692,
    height: 46.1538,
    rx: 4,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 199.231,
    y: 196.922,
    width: 27.6923,
    height: 46.1538,
    rx: 4,
    fill: "#A3ACC2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 233.077,
    y: 200.769,
    width: 24.6154,
    height: 15.3846,
    rx: 4,
    fill: "#A3ACC2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 233.077,
    y: 222.306,
    width: 24.6154,
    height: 3.07692,
    rx: 1.53846,
    fill: "#A3ACC2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 233.077,
    y: 226.922,
    width: 24.6154,
    height: 3.07692,
    rx: 1.53846,
    fill: "#A3ACC2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 233.077,
    y: 231.538,
    width: 24.6154,
    height: 3.07692,
    rx: 1.53846,
    fill: "#A3ACC2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 233.077,
    y: 236.152,
    width: 24.6154,
    height: 3.07692,
    rx: 1.53846,
    fill: "#A3ACC2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 200.769,
    width: 6.15385,
    height: 1.53846,
    rx: 0.769231,
    fill: "#A3ACC2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 200.769,
    width: 3.07692,
    height: 1.53846,
    rx: 0.769231,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 205.383,
    width: 6.15385,
    height: 1.53846,
    rx: 0.769231,
    fill: "#A3ACC2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 205.383,
    width: 3.07692,
    height: 1.53846,
    rx: 0.769231,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 209.999,
    width: 6.15385,
    height: 1.53846,
    rx: 0.769231,
    fill: "#A3ACC2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 209.999,
    width: 3.07692,
    height: 1.53846,
    rx: 0.769231,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 214.613,
    width: 6.15385,
    height: 1.53846,
    rx: 0.769231,
    fill: "#A3ACC2"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 214.613,
    width: 3.07692,
    height: 1.53846,
    rx: 0.769231,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 219.23,
    width: 6.15385,
    height: 1.53846,
    rx: 0.769231,
    fill: "#A3ACC2"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 219.23,
    width: 3.07692,
    height: 1.53846,
    rx: 0.769231,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 223.844,
    width: 6.15385,
    height: 1.53846,
    rx: 0.769231,
    fill: "#A3ACC2"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 223.844,
    width: 3.07692,
    height: 1.53846,
    rx: 0.769231,
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 228.461,
    width: 6.15385,
    height: 1.53846,
    rx: 0.769231,
    fill: "#A3ACC2"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 228.461,
    width: 3.07692,
    height: 1.53846,
    rx: 0.769231,
    fill: "white"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 233.077,
    width: 6.15385,
    height: 1.53846,
    rx: 0.769231,
    fill: "#A3ACC2"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 233.077,
    width: 3.07692,
    height: 1.53846,
    rx: 0.769231,
    fill: "white"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 237.691,
    width: 6.15385,
    height: 1.53846,
    rx: 0.769231,
    fill: "#A3ACC2"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 225.385,
    y: 237.691,
    width: 3.07692,
    height: 1.53846,
    rx: 0.769231,
    fill: "white"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 310.5,
    y: 60.5,
    width: 79,
    height: 79,
    rx: 7.5,
    fill: "#0B2878",
    stroke: "#0B2878"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 319.231,
    y: 100,
    width: 61.5385,
    height: 7.69231,
    rx: 3.84615,
    fill: "#A3ACC2"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 319.231,
    y: 100,
    width: 30.7692,
    height: 7.69231,
    rx: 3.84615,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M326.923 107.694H373.077V115.079C373.077 119.497 369.495 123.079 365.077 123.079H334.923C330.505 123.079 326.923 119.497 326.923 115.079V107.694Z",
    fill: "#A3ACC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M326.923 109.233H342C346.418 109.233 350 112.815 350 117.233V123.08H334.923C330.505 123.08 326.923 119.498 326.923 115.08V109.233Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M343.964 76.9219H361.384C363.593 76.9219 365.384 78.7127 365.384 80.9219V88.3065C365.384 90.5156 363.593 92.3065 361.384 92.3065H343.964C342.903 92.3065 341.886 91.8851 341.136 91.1349L337.444 87.4426C335.881 85.8805 335.881 83.3479 337.444 81.7858L341.136 78.0934C341.886 77.3433 342.903 76.9219 343.964 76.9219Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 339.23,
    cy: 84.6137,
    r: 1.53846,
    fill: "#A3ACC2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M359.231 76.9219H361.384C363.594 76.9219 365.384 78.7127 365.384 80.9219V88.3065C365.384 90.5156 363.594 92.3065 361.384 92.3065H359.231V76.9219Z",
    fill: "#A3ACC2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M348.922 88.9939H351.018V91.3139C350.933 91.3352 350.805 91.3565 350.634 91.3779C350.464 91.4099 350.282 91.4259 350.09 91.4259C349.685 91.4259 349.386 91.3512 349.194 91.2019C349.013 91.0632 348.922 90.8072 348.922 90.4339V88.9939ZM351.018 81.4579H348.922V78.8019C349.008 78.7699 349.136 78.7432 349.306 78.7219C349.477 78.6899 349.658 78.6739 349.85 78.6739C350.266 78.6739 350.565 78.7485 350.746 78.8979C350.928 79.0365 351.018 79.2925 351.018 79.6659V81.4579ZM349.642 88.2099C350.218 88.2099 350.629 88.1085 350.874 87.9059C351.13 87.6925 351.258 87.4419 351.258 87.1539C351.258 86.8872 351.157 86.6739 350.954 86.5139C350.762 86.3432 350.474 86.1992 350.09 86.0819L349.242 85.8099C348.666 85.6179 348.16 85.4045 347.722 85.1699C347.285 84.9352 346.944 84.6312 346.698 84.2579C346.453 83.8845 346.33 83.4099 346.33 82.8339C346.33 81.9485 346.666 81.2445 347.338 80.7219C348.01 80.1992 348.944 79.9379 350.138 79.9379C350.746 79.9379 351.285 79.9965 351.754 80.1139C352.234 80.2312 352.608 80.4072 352.874 80.6419C353.152 80.8659 353.29 81.1432 353.29 81.4739C353.29 81.7192 353.232 81.9325 353.114 82.1139C353.008 82.2845 352.869 82.4339 352.698 82.5619C352.453 82.3912 352.128 82.2472 351.722 82.1299C351.317 82.0019 350.869 81.9379 350.378 81.9379C349.866 81.9379 349.482 82.0232 349.226 82.1939C348.97 82.3539 348.842 82.5672 348.842 82.8339C348.842 83.0472 348.928 83.2232 349.098 83.3619C349.269 83.4899 349.525 83.6072 349.866 83.7139L350.746 83.9859C351.717 84.2845 352.464 84.6845 352.986 85.1859C353.509 85.6765 353.77 86.3379 353.77 87.1699C353.77 88.0659 353.424 88.7965 352.73 89.3619C352.037 89.9165 351.034 90.1939 349.722 90.1939C349.072 90.1939 348.49 90.1245 347.978 89.9859C347.466 89.8472 347.056 89.6445 346.746 89.3779C346.448 89.1112 346.298 88.8019 346.298 88.4499C346.298 88.1725 346.378 87.9379 346.538 87.7459C346.709 87.5432 346.896 87.3939 347.098 87.2979C347.386 87.5325 347.744 87.7459 348.17 87.9379C348.608 88.1192 349.098 88.2099 349.642 88.2099Z",
    fill: "#A3ACC2"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 180.5,
    width: 79,
    height: 79,
    rx: 7.5,
    fill: "#0B2878",
    stroke: "#0B2878"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.154 217.229C116.154 212.81 119.736 209.229 124.154 209.229H132.769C137.188 209.229 140.769 212.81 140.769 217.229V235.075C140.769 239.493 137.188 243.075 132.769 243.075H116.154V217.229Z",
    fill: "#A3ACC2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.154 216.921C116.154 212.672 119.598 209.229 123.846 209.229C128.095 209.229 131.539 212.672 131.539 216.921V235.075C131.539 239.493 127.957 243.075 123.539 243.075H116.154V216.921Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.308 203.075C122.308 199.676 125.063 196.921 128.462 196.921H130C132.549 196.921 134.615 198.987 134.615 201.536C134.615 204.085 132.549 206.152 130 206.152H122.308V203.075Z",
    fill: "#A3ACC2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M122.308 200.767C122.308 198.643 124.03 196.921 126.154 196.921C128.278 196.921 130 198.643 130 200.767V201.536C130 204.085 127.934 206.152 125.385 206.152H122.308V200.767Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8462 226.921H113.077V235.075C113.077 239.493 109.495 243.075 105.077 243.075H91.8462C87.4279 243.075 83.8462 239.493 83.8462 235.075V226.921Z",
    fill: "#A3ACC2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8462 226.921H93.077V238.459C93.077 241.008 91.0106 243.075 88.4616 243.075C85.9126 243.075 83.8462 241.008 83.8462 238.459V226.921Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2307 220.766C79.2307 219.067 80.6083 217.689 82.3076 217.689H106.923C110.322 217.689 113.077 220.445 113.077 223.843H82.3076C80.6083 223.843 79.2307 222.466 79.2307 220.766Z",
    fill: "#A3ACC2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2307 220.766C79.2307 219.067 80.6083 217.689 82.3076 217.689H89.9999C91.6993 217.689 93.0769 219.067 93.0769 220.766C93.0769 222.466 91.6993 223.843 89.9999 223.843H82.3076C80.6083 223.843 79.2307 222.466 79.2307 220.766Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4617 214.613C88.4617 213.763 89.1505 213.074 90.0001 213.074H105.385C106.234 213.074 106.923 213.763 106.923 214.613H88.4617Z",
    fill: "#A3ACC2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4617 214.613C88.4617 213.763 89.1505 213.074 90.0001 213.074H96.9232C97.348 213.074 97.6924 213.419 97.6924 213.843C97.6924 214.268 97.348 214.613 96.9232 214.613H88.4617Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M103.846 206.921L97.6925 213.075H99.231L103.846 208.459H105.385V206.921H103.846Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M104.615 207.69C104.615 206.84 105.304 206.151 106.154 206.151H110C110.85 206.151 111.539 206.84 111.539 207.69C111.539 208.539 110.85 209.228 110 209.228H106.154C105.304 209.228 104.615 208.539 104.615 207.69Z",
    fill: "#A3ACC2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M104.615 207.69C104.615 206.84 105.304 206.151 106.154 206.151C107.004 206.151 107.692 206.84 107.692 207.69C107.692 208.539 107.004 209.228 106.154 209.228C105.304 209.228 104.615 208.539 104.615 207.69Z",
    fill: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 70.5,
    y: 60.5,
    width: 79,
    height: 79,
    rx: 7.5,
    fill: "#0B2878",
    stroke: "#0B2878"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 79.2307,
    y: 99.998,
    width: 61.5385,
    height: 7.69231,
    rx: 3.84615,
    fill: "#A3ACC2"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 79.2307,
    y: 99.998,
    width: 30.7692,
    height: 7.69231,
    rx: 3.84615,
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9231 107.689H133.077V115.074C133.077 119.492 129.495 123.074 125.077 123.074H94.9231C90.5048 123.074 86.9231 119.492 86.9231 115.074V107.689Z",
    fill: "#A3ACC2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9231 109.229H102C106.418 109.229 110 112.81 110 117.229V123.075H94.9231C90.5048 123.075 86.9231 119.493 86.9231 115.075V109.229Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M105.385 99.9984C105.385 99.1488 106.073 98.46 106.923 98.46H113.077C113.926 98.46 114.615 99.1488 114.615 99.9984H105.385Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M110 99.6143H137.692",
    stroke: "white",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M137.692 111.537L137.692 99.614",
    stroke: "white",
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M136.923 112.69C136.923 112.265 137.267 111.921 137.692 111.921C138.117 111.921 138.461 112.265 138.461 112.69V114.998H136.923V112.69Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M137.692 112.689C137.692 112.477 137.864 112.305 138.077 112.305C138.289 112.305 138.461 112.477 138.461 112.689V114.997H137.692V112.689Z",
    fill: "#A3ACC2"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 137.308,
    y: 111.537,
    width: 0.769231,
    height: 0.769231,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 84.6142,
    r: 7.69231,
    fill: "white"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 109.231,
    y: 81.5371,
    width: 1.53846,
    height: 6.15385,
    rx: 0.769231,
    fill: "#A3ACC2"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 106.923,
    y: 83.8447,
    width: 6.15385,
    height: 1.53846,
    rx: 0.769231,
    fill: "#A3ACC2"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 190.5,
    y: 60.5,
    width: 79,
    height: 79,
    rx: 7.5,
    fill: "#0B2878",
    stroke: "#0B2878"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 206.923,
    y: 88.4609,
    width: 46.1539,
    height: 12.3077,
    fill: "white"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 206.923,
    y: 96.9219,
    width: 46.1539,
    height: 3.84615,
    fill: "#A3ACC2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M205.385 88.4609H201.231C200.126 88.4609 199.231 89.3564 199.231 90.4609V98.7686C199.231 99.8732 200.126 100.769 201.231 100.769H205.385V88.4609Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M205.385 96.9219H199.231V98.768C199.231 99.8726 200.126 100.768 201.231 100.768H205.385V96.9219Z",
    fill: "#A3ACC2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M254.615 88.4609H258.769C259.874 88.4609 260.769 89.3564 260.769 90.4609V98.7686C260.769 99.8732 259.874 100.769 258.769 100.769H254.615V88.4609Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M254.615 96.9219H260.769V98.768C260.769 99.8726 259.874 100.768 258.769 100.768H254.615V96.9219Z",
    fill: "#A3ACC2"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 226.154,
    y: 88.4609,
    width: 7.69231,
    height: 19.2308,
    fill: "#A3ACC2"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M226.154 111.538V107.691H233.846V111.538L230 108.461L226.154 111.538Z",
    fill: "#A3ACC2"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13202_46797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.1538,
    height: 46.1538,
    fill: "white",
    transform: "translate(319.231 196.922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup300);
export default __webpack_public_path__ + "static/media/Group300.9a79d95f891e26b7b644309c1ff71632.svg";
export { ForwardRef as ReactComponent };